export const IMG_HERO =
  "https://images.unsplash.com/photo-1616276720362-3d2aceadffbd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800";
export const IMG_FERN =
  "https://images.unsplash.com/photo-1700425903644-205f383f301a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
export const IMG_COAST =
  "https://images.unsplash.com/photo-1791167384992-791e41b9bf23?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";
